import { RegistrationField } from 'store/serviceRegistration/types';

export const isFormFilled = (registrationInfo: Array<RegistrationField>, isTermAccepted: boolean): boolean =>
  registrationInfo?.length >= 0 &&
  registrationInfo.filter(question => question.required && question.value && question.value !== '').length ===
    registrationInfo.filter(question => question.required).length &&
  isTermAccepted;
